<div class="flex flex-col gap-2">
  @if (item() && instance() && (!instance().history || instance().history.length == 0)) {
    <empty-state
      icon="history_off"
      [title]="'internal.inventory.itemHistory.empty.title' | translate"
      [subtitle]="'internal.inventory.itemHistory.empty.subtitle' | translate"
    >
    </empty-state>
  }

  <p-timeline [pt]="{ eventOpposite: { class: 'hidden' } }" [value]="instance().history">
    <ng-template #marker let-event>
      <span class="flex w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm">
        <mat-icon>{{ eventIcon(event.eventtype) }}</mat-icon>
      </span>
    </ng-template>
    <ng-template #content let-event>
      <div class="flex flex-col">
        <span class="flex flex-row gap-1 items-center">
          {{ eventMessage(event) | translate }}

          @if (loadedTransactions()[instance().history.indexOf(event)]) {
            @if (transactionById(event.transactionid)) {
              <span class="font-bold">{{ transactionById(event.transactionid)?.location }}</span>
            }
          } @else {
            <p-skeleton height="1.3125rem" width="4rem" />
          }
        </span>

        <div class="text-muted-color flex flex-row gap-1">
          <span>{{ event.date | date: 'short' }}</span>

          @if (loadedTransactions()[instance().history.indexOf(event)]) {
            @if (userById(event.userid) && event.date) {
              <span> • </span>
            }
            @if (userById(event.userid)) {
              <span>{{ userById(event.userid)?.fullname }}</span>
            }
          } @else {
            <p-skeleton height="1.3125rem" width="7rem" />
          }
        </div>

        @if (loadedTransactions()[instance().history.indexOf(event)]) {
          <p-button
            [label]="'internal.inventory.itemHistory.showTransaction' | translate"
            class="mb-4"
            [text]="true"
            (onClick)="showTransaction(event.transactionid)"
          />
        } @else {
          <p-skeleton class="mb-4" height="2.5625rem" width="9.375rem" />
        }
      </div>
    </ng-template>
  </p-timeline>
</div>

<div class="flex justify-end gap-2 mt-4">
  <p-button
    [label]="'general.close' | translate"
    severity="secondary"
    (onClick)="dialogRef.close()"
  />
</div>
